module.exports = __webpack_public_path__ + "static/media/city_night.8a9395f2.jpg";